import Component from '../core/Component'
import { queryAll } from '../utils/dom'

export default class FormOrderPriceRegion extends Component {
    constructor(element) {
        super(element)

        this.price = 0
    }

    prepare() {
        this.element.addEventListener('change', this.handleChange)
        this.calculate()
    }

    handleChange = event => {
        this.calculate()
    }

    reset() {
        queryAll('input[type="checkbox"], input[type="radio"]', this.element)
            .forEach(element => element.checked = false)

        this.calculate(true)
    }

    calculate(silent = false) {
        this.price = queryAll('input[type="checkbox"], input[type="radio"]', this.element)
            .filter(element => element.checked)
            .map(element => element.dataset.price ? parseInt(element.dataset.price) : 0)
            .reduce((acc, value) => acc + value, 0)

        if (!silent) {
            this.emit('change', {
                price: this.price
            })
        }
    }
}
